import { Routes } from '@angular/router';
import { guestGuard, guestMatchGuard, authMatchGuard } from './core/guards/auth.guard';
import { roleMatchGuard } from './core/guards/role.guard';
import { ROUTE_SEGMENTS } from './core/constants/routes.constants';
import { ProjectService } from './admin/services/project.service';
import { SettingsService } from './admin/services/settings.service';
import { AiDetectionApiService } from './admin/services/ai-detection-api.service';
import { DrywallApiService } from './admin/services/drywall-api.service';
import { FlooringApiService } from './admin/services/flooring-api.service';
import { PlumbingApiService } from './admin/services/plumbing-api.service';
import { InteriorPaintApiService } from './admin/services/interior-paint-api.service';
import { DoorsWindowsApiService } from './admin/services/doors-windows-api.service';

export const routes: Routes = [
  // Landing
  {
    path: ROUTE_SEGMENTS.home,
    pathMatch: 'full',
    canActivate: [guestGuard],
    loadComponent: () => import('./landing/landing-page/landing-page.component').then(m => m.LandingComponent),
  },

  // Auth — redirect to dashboard if already logged in
  {
    path: ROUTE_SEGMENTS.auth.root,
    canMatch: [guestMatchGuard],
    loadComponent: () => import('./layouts/auth-layout/auth-layout.component').then(m => m.AuthLayout),
    loadChildren: () => import('./auth/auth.routes').then(m => m.authRoutes),
  },

  // Admin — must be authenticated + have admin role
  {
    path: ROUTE_SEGMENTS.admin.root,
    canMatch: [authMatchGuard, roleMatchGuard('admin')],
    providers: [
      ProjectService,
      SettingsService,
      AiDetectionApiService,
      DrywallApiService,
      FlooringApiService,
      PlumbingApiService,
      InteriorPaintApiService,
      DoorsWindowsApiService,
    ],
    loadComponent: () => import('./layouts/admin-layout/admin-layout.component').then(m => m.AdminLayout),
    loadChildren: () => import('./admin/admin.routes').then(m => m.adminRoutes),
  },

  // Builder — must be authenticated + have builder role
  {
    path: ROUTE_SEGMENTS.builder.root,
    canMatch: [authMatchGuard, roleMatchGuard('builder')],
    loadComponent: () => import('./layouts/builder-layout/builder-layout.component').then(m => m.BuilderLayout),
    loadChildren: () => import('./builder/builder.routes').then(m => m.builderRoutes),
  },

  // Pricing report — standalone print page, no layout wrapper
  {
    path: ROUTE_SEGMENTS.pricingReport,
    title: 'Pricing Report',
    loadComponent: () => import('./shared/components/reports/pricing-report/pricing-report.component').then(m => m.PricingReportComponent),
  },

  // 404 — catch all unmatched routes
  {
    path: ROUTE_SEGMENTS.notFound,
    loadComponent: () => import('./not-found/not-found.component').then(m => m.NotFoundComponent),
  },
];
